var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('p',{staticStyle:{"opacity":"0","height":"0","width":"0","overflow":"hidden"}},[_vm._v("Pipeline migration test")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }